import { render, staticRenderFns } from "./AppNavItemLink.vue?vue&type=template&id=362a50bc&functional=true&"
import script from "./AppNavItemLink.vue?vue&type=script&lang=js&"
export * from "./AppNavItemLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports